'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _EyeOutlined = _interopRequireDefault(require('./lib/icons/EyeOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _EyeOutlined;
exports.default = _default;
module.exports = _default;